// Module
var code = `<div class="market-depth-panel">
    <div class="market-depth-panel-lookup-sector">
        <terceraInstrumentLookup mayContainTrees="true" selectedItem="{{instrument}}" selectedAccount="{{account}}" />
        <accountSelector selectedItem="{{.account}}" visible="{{!.singleAccount}}" />
    </div>
    <terceraLevel1Panel name="lvl1Panel"
                        level1Types="{{level1Types}}"
                        account="{{account}}"
                        instrument="{{instrument}}"
                        visible="{{visibilityLvl1}}" />
    <div class="market-depth-panel-table-sector">
        <div class="js-market-depth-table">
            <terceraPanel name='windowPanelBodyQT' />

            <dataSourceWidget comboBoxButtonType="false" fromMarketDepth="true"
                              visible="{{visibilityDataSource}}"
                              opened="{{DataSourceOpened}}"
                              instrument="{{instrument}}"
                              account="{{account}}" />
        </div>

        {{#if visibilityPos}}
            <instrumentTotalInfo name="instrumentTotalInfoPanel"
                                 account="{{account}}"
                                 instrument="{{instrument}}" />
        {{/if}}
    </div>

    {{#if visibilityOE}}
    <div class="js-market-depth-buttons">
        <div class="market-depth-oe">
            <div class="js-controls-MD">
                <div class="js-controls-MD-column">
                    <OEOrderTypeSelector showLabel="false"
                                        instrument="{{instrument}}"
                                        account="{{account}}"
                                        orderType="{{orderType}}" />
                </div>

                <div class="js-controls-MD-column">
                    <OETIFSelector showLabel="false"
                                orderType="{{orderType}}"
                                instrument="{{instrument}}"
                                tif="{{tif}}" />
                </div>

                <div class="js-controls-MD-column">
                    <OEProductTypeSelector showLabel="false"
                                        instrument="{{instrument}}"
                                        account="{{account}}"
                                        visible="{{visibilityProductType}}"
                                        productType="{{productType}}" />

                    {{#if !visibilityProductType}}
                        {{#if visibilityLeverage}}
                            <OELeverageSelector name="leverageControl"
                                                instrument="{{instrument}}"
                                                account="{{account}}"
                                                productType="{{productType}}"
                                                leverageValue="{{leverageValue}}" />
                        {{elseif isVisibleOTHTrading}}
                            <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                                            textKey="{{overnightExecutionTextKey}}" 
                                                            tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                                            events="{{isAllowOTHTradingEvents}}"/>
                        {{/if}}
                    {{/if}}
                </div>
            </div>

            <div class="js-controls-MD">
                <div class="js-controls-MD-column">
                    <OEQuantity showLabel="false"
                                account="{{account}}"
                                instrument="{{instrument}}"
                                quantity="{{quantity}}"
                                defaultQuantity="{{defaultQuantity}}" />
                </div>

                <div class="js-controls-MD-column" as-tooltip="shortCaptionsTooltip[0]">
                    {{#if orderEditParameterArray[0] && orderEditParameterArray[0].type === DynProperty.DOUBLE}}
                        <terceraLabel text="{{shortCaptions[0]}}" additionalClass="oe-short-caption" />
                        <DPTradingNumeric showLabel="false"
                                        instrument="{{instrument}}"
                                        dp="{{orderEditParameterArray[0]}}"
                                        name="{{orderEditParameterArray[0].name}}"
                                        PriceNumericLink="{{PriceNumericLink}}"
                                        StopPriceNumericLink="{{StopPriceNumericLink}}" />
                    {{/if}}
                </div>

                <div class="js-controls-MD-column" as-tooltip="shortCaptionsTooltip[1]">
                    {{#if orderEditParameterArray[1] && orderEditParameterArray[1].type === DynProperty.DOUBLE}}
                        <terceraLabel text="{{shortCaptions[1]}}" additionalClass="oe-short-caption" />
                        <DPTradingNumeric showLabel="false"
                                        instrument="{{instrument}}"
                                        dp="{{orderEditParameterArray[1]}}"
                                        name="{{orderEditParameterArray[1].name}}"
                                        PriceNumericLink="{{PriceNumericLink}}" />
                    {{/if}}

                    {{#if enableComment}}
                        <OEComment userComment="{{userComment}}" showLabel="false" on-valueChanged="onUserCommentChanged"/>
                    {{/if}}
                </div>
            </div>
        </div>

        {{#if visibilityProductType && (visibilityLeverage || isVisibleOTHTrading)}}
            <div class="js-controls-MD">
                <div class="js-controls-MD-column">
                    {{#if visibilityLeverage}}
                        <OELeverageSelector showLabel="false"
                                            name="leverageControl"
                                            instrument="{{instrument}}"
                                            account="{{account}}"
                                            productType="{{productType}}"
                                            leverageValue="{{leverageValue}}" />
                    {{elseif isVisibleOTHTrading}}
                        <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                                        textKey="{{overnightExecutionTextKey}}" 
                                                        tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                                        events="{{isAllowOTHTradingEvents}}"/>
                    {{/if}}
                </div>
                <div class="js-controls-MD-column">
                    {{#if visibilityLeverage && isVisibleOTHTrading}}
                        <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                                        textKey="{{overnightExecutionTextKey}}" 
                                                        tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                                        events="{{isAllowOTHTradingEvents}}"/>
                    {{/if}}
                </div>
                <div class="js-controls-MD-column"></div>
            </div>
        {{/if}}

        <div class="js-controls-MD">
            <BuySellMDButton side="{{leftBtnSide}}"
                             tradingAllowed="{{tradingAllowed}}" tradingForbiddenReason="{{tradingForbiddenReason}}"
                             on-btnClick="placeOrder" />

            <CancelOrdersMDButton instrument="{{instrument}}"
                                  account="{{account}}" />

            <BuySellMDButton side="{{rightBtnSide}}"
                             tradingAllowed="{{tradingAllowed}}" tradingForbiddenReason="{{tradingForbiddenReason}}"
                             on-btnClick="placeOrder" />
        </div>
    </div>
    {{/if}}
</div>`;
// Exports
export default code;